import { LocaleKeys } from '../../../../locale/translation-types'

export enum ConveyanceTypeEnum {
  WALK = 'WALK',
  BUS = 'BUS',
  TRAIN = 'TRAIN'
}

export const conveyanceTypeEnumMapping: Record<ConveyanceTypeEnum, LocaleKeys> = {
  [ConveyanceTypeEnum.BUS]: 'conveyance.type.bus',
  [ConveyanceTypeEnum.TRAIN]: 'conveyance.type.train',
  [ConveyanceTypeEnum.WALK]: 'conveyance.type.walk'
}
